// src/SearchField.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box/index.js";
import TextField from "@mui/material/TextField/index.js";
import { jsx } from "react/jsx-runtime";
var SearchField = ({
  label,
  sx,
  InputProps,
  initialValue = "",
  autoFocus,
  onBlur,
  onKeyDown
}) => {
  const navigate = useNavigate();
  const [value, setValue] = useState(initialValue);
  const handleSubmit = (event) => {
    event.preventDefault();
    const trimmed = value.trim();
    if (!trimmed) return;
    navigate(`/search?q=${encodeURIComponent(trimmed)}`);
  };
  return /* @__PURE__ */ jsx(Box, { component: "form", onSubmit: handleSubmit, sx, children: /* @__PURE__ */ jsx(
    TextField,
    {
      fullWidth: true,
      type: "search",
      value,
      onChange: (event) => setValue(event.target.value),
      label,
      InputProps,
      autoFocus,
      onBlur,
      onKeyDown
    }
  ) });
};

export {
  SearchField
};
